module.exports = __webpack_public_path__ + "static/media/thumb-up.2cf56bc5.png";